import { createSlice } from '@reduxjs/toolkit';
import { HttpRequestType } from '../../adapters/xhr/RequestStatus';
import { ApiURLs, API_BASE_URL } from '../../common/url';
import { AsyncThunkAction } from '../asyncThunk';
const initialState = {
    dataFilter : {
        fields : [],
        template : "",
    },
    listingData: []

}


export const getDataList = AsyncThunkAction('data/listing/get', API_BASE_URL + ApiURLs.Data.Listing)
export const upsertDataListing = AsyncThunkAction('data/listing/update', API_BASE_URL + ApiURLs.Data.Listing, HttpRequestType.PUT)
export const deleteDataListing = AsyncThunkAction('data/listing/delete', API_BASE_URL + ApiURLs.Data.Listing, HttpRequestType.DELETE)
export const validateEmailExistsAlready = AsyncThunkAction('data/validateEmailExistsAlready', API_BASE_URL + ApiURLs.Data.getEmail)
export const getMasterData = AsyncThunkAction('data/masterdata', API_BASE_URL + ApiURLs.Data.masterData)
export const getDocVersionList = AsyncThunkAction('data/listing/version', API_BASE_URL + ApiURLs.Data.versionListing)

const dataListingSlice = createSlice({
    name: 'document',
    initialState: initialState,
    reducers: {
           setListingData : (state, action)=>{
            state.dataFilter = action.payload
        
           },
           
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(getDataList.pending, (state, action) => {
    //         })
    //         .addCase(getDataList.fulfilled, (state, action) => {
    //             if (action.payload.status === 200) {
    //                 state.listingData = action.payload.data

    //             }
    //         }).addCase(getDataList.rejected, (state, action) => {
    //         })
    // }
})

 export const { setListingData,setTemplateData } = dataListingSlice.actions;
export default dataListingSlice.reducer